import { z } from 'zod';

import { DependentRelation } from '@/common/graphql';

export const DependentRelationLabels: Record<DependentRelation, string> = {
  [DependentRelation.Spouse]: 'Spouse',
  [DependentRelation.Child]: 'Child',
  [DependentRelation.AdoptedChild]: 'Adpoted child',
  [DependentRelation.Parent]: 'Parent',
  [DependentRelation.Sibling]: 'Sibling',
  [DependentRelation.Other]: 'Others',
};

export const EmployeeDependent = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  relation: z.nativeEnum(DependentRelation).default(DependentRelation.Other),
  dateOfBirth: z.string().default(''),
  age: z.number().default(0),
});
export type EmployeeDependentType = z.infer<typeof EmployeeDependent>;
